// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportsTable_wrapper_il56O"};